const step = (targetEl, title, content, falc, permission = null) => {
  return {
      element: targetEl,
      title: title,
      content: content,
      content_falc: falc,
      permission: permission,
  };
}

const page = (name, url, steps) => {
    return {name: name, url: url, steps: steps}
}

export default {
    /* ******************************************************************
        DASHBOARD STEPS
    ****************************************************************** */
  pages: [
    page(
      "dashboard",
      "/",
      [
        step(
        "menu-neopass-list", '',
        'C’est ici que vous allez pouvoir renseigner l’ensemble de vos informations personnelles et professionnelles',
        'Renseignez ici vos informations personnelles et professionnelles.'
        ),
      ]
    ),
    page(
      "neopass_form_infos_generales",
      /\/form\/neopass\/\d+\/cv\/informationsgenerales/,
      [
        step(
          "form-intitule", "",
          "Renseignez les informations importantes qui vous serviront pour votre CV ou dans le cadre de votre accompagnement”. Parmi ces informations,  nous vous conseillons d’indiquer votre téléphone, adresse mail.",
          "Complétez les champs de votre choix en cliquant dessus."
        ),
        step(
          "form-infos-generales","",
          "Cette partie propose des champs complémentaires concernant votre suivis Pôle emploi,  votre situation de handicap etc… Les informations datées (comme la fin de votre RQTH) seront notamment reprisent sur votre frise chronologique",
          "Informations complémentaires à renseigner."
        ),
        step(
          "form-contacts","",
          "Cette partie vous propose d’indiquer les personnes ou structures à contacter en cas de nécessité",
          "Indiquez les personnes à contacter en cas de nécessité."
        ),
        step(
          "form-menu-situationpersonnelle","Suite du parcours",
          "Suite du parcours",
          ""
        ),
      ]
      ),
    page(
      "neopass_form_situation_perso",
      /\/form\/neopass\/\d+\/cv\/situationpersonnelle/,
      [
        step(
          "form-add-evenement", "",
          "Dans cette partie, vous pouvez indiquer tous les évènements importants qui se sont déroulés dans votre parcours de vie.",
          "Indiquez les principaux évènements de votre parcours de vie."
        ),
        step(
          "form-action-frise", "",
          "Ils apparaitront ainsi sur votre frise chronologique",
          "Illustration graphique de votre parcours de vie."
        ),
        step(
          "form-menu-situationprofessionnelle", "Suite du parcours",
          "",
          ""
        )
      ]
    ),
    page(
      "neopass_form_situation_pro",
      /\/form\/neopass\/\d+\/cv\/situationprofessionnelle/,
      [
        step(
          "form-situation-pro", "",
          "Dans cette partie, vous pouvez préciser votre situation professionnelle et précisez vos certificats, habilitations professionnelles etc...",
          "Complétez les champs de votre choix en cliquant dessus."
        ),
        step(
          "form-certif", "",
          "...",
          "Complétez les champs de votre choix en cliquant dessus."
        ),
        step(
          "form-habilitation", "",
          "...",
          "Complétez les champs de votre choix en cliquant dessus."
        ),
        step(
          "form-diplome", "",
          "...",
          "Complétez les champs de votre choix en cliquant dessus."
        ),
        step(
          "form-menu-parcours", "Suite du parcours",
          "",
          ""
        ),
      ]
    ),
    page(
      "neopass_form_parcours",
      /\/form\/neopass\/\d+\/cv\/parcours/,
      [
        step(
          "add-parcours", "",
          "",
          "Cliquez sur ce champ pour ajouter un parcours.",
        ),
        step(
          "form-action-frise", "",
          "Renseigner vos différentes expériences formatives (professionnelles et/ou éducatives), personnelles, bénévoles et professionnelles afin de les mettre en avant dans votre CV et les voir apparaître sur votre frise chronologique",
          "Illustration graphique de votre parcours de vie.",
        ),
        step(
          "form-menu-portfolio", "Suite du parcours",
          "",
          ""
        )
      ]
    ),
    page(
      "neopass_form_portfolio",
      /\/form\/neopass\/\d+\/cv\/portfolio/,
      [
        step(
          "neopass_form_portfolio",
          "",
          "Cette partie mets en avant vos réalisations personnelles et professionnelles à travers des images et des photos.",
          "Ajoutez des images ou photos de votre choix.",
        )
      ]
    ),
    page(
      "neopass_form_competences_perso",
      /\/form\/neopass\/\d+\/compperso\/extrapro/,
      [
        step(
          "extrapro_add_activity",
          "",
          "Mettez en avant vos activités extraprofessionnelles et les compétences associées à ces activités.",
          "Ajoutez les activités extraprofessionnelles de votre choix."
        ),
        step(
          "form-menu-compcle",
          "",
          "A vous de jouer, créer une période d’évaluation puis accéder à votre formulaire d’évaluation pour vous auto évaluer sur vos compétences clés, informatique et linguistique",
          "Auto-évaluez vos compétences clés."
        ),
        step(
          "form-menu-informatique",
          "",
          "A vous de jouer, créer une période d’évaluation puis accéder à votre formulaire d’évaluation pour vous auto évaluer sur vos compétences clés, informatique et linguistique",
          "Auto-évaluez vos compétences informatiques."
        ),
        step(
          "form-menu-langue",
          "",
          "A vous de jouer, créer une période d’évaluation puis accéder à votre formulaire d’évaluation pour vous auto évaluer sur vos compétences clés, informatique et linguistique",
          "Auto-évaluez vos compétences linguistiques."
        ),
      ]
    ),
    page(
      "neopass_form_competences_socio_pro",
      /\/form\/neopass\/\d+\/compsocio\/\w+/,
      [
        step(
          "user-menu", "",
          "",
          "Pour accéder à ces formulaires d’évaluation et bénéficier d’un espace d’auto évaluation, vous devez aller dans \"Gestion invités\"."
        ),
        step(
          "form-menu-plan", "Suite du parcours",
          "",
          ""
        )
      ]
    ),
    page(
      "neopass_form_competences_pro",
      /\/form\/neopass\/\d+\/comppro\/\w+/,
      [
        step(
          "user-menu", "",
          "",
          "Pour accéder à ces formulaires d’évaluation et bénéficier d’un espace d’auto évaluation, vous devez aller dans \"Gestion invités\"."
        ),
        step(
          "form-menu-plan", "",
          "Suite du parcours",
          ""
        )
      ]
    ),
    page(
      "neopass_form_plan_accompagnement",
      /\/form\/neopass\/\d+\/plan\/\w+/,
      [
        step(
          "user-menu", "",
          "Pour accéder à Bilan et Projet, veuillez vous rendre dans la \"Gestion invités\". Et invitez un professionnel qui vous accompagne à rejoindre votre Neopass de manière sécurisé.",
          "Pour accéder à Bilan et Projet, veuillez vous rendre dans la \"Gestion invités\". Et invitez un professionnel qui vous accompagne à rejoindre votre Neopass de manière sécurisée"
        ),
        step(
          "form-menu-compterendu", "",
          "Il vous est possible de prendre des notes et de les historiser",
          "Créez vos notes et compte-rendus en cliquant sur ajouter."
        )
      ]
    ),
    page(
      "neopass_form_preco_emploi_stage",
      /\/form\/neopass\/\d+\/preconisation\/\w+/,
      [
        step(
          "form-menu-accessibilite", "",
          "Préciser les aménagements dont vous avez besoin et partager les à votre futur employeur",
          "Renseignez ici votre (vos) besoin(s) en matière accessibilité."
        ),
        step(
          "form-menu-poste", "",
          "Préciser les aménagements dont vous avez besoin et partager les à votre futur employeur",
          "Renseignez ici votre (vos) besoin(s) d'aménagement."
        ),
        step(
          "form-menu-autonomie", "",
          "Préciser les aménagements dont vous avez besoin et partager les à votre futur employeur",
          "Renseignez ici votre (vos) niveau(x) d'autonomie."
        )
      ]
    ),
    page(
      "depot_doc", "/documents",
      [
        step(
          "add-folder", "",
          "Callez vos differents documents en créant des dossiers",
          "Classez vos fichiers en créant des dossiers et sous-dossiers."
        ),
        step(
          "add-file", "",
          "Importez les documents dont vous avez besoin pour vos démarches personnelles ou professionnelles",
          "Importez les fichiers de votre choix."
        )
      ]
    ),
    page(
      "sheets", "/fiches-de-poste",
      [
        step(
          "tour_shared_library", "",
          "",
          "Accédez à la bibliothèque commune.",
        ),
        step(
          "add-desc", "",
          "",
          "Ajoutez une fiche de poste à votre bibliothèque personnelle.",
        ),
        step(
          "tour_personal_library", "",
          "",
          "Accédez à la bibliothèque personnelle.",
        ),
        step(
          "edit-desc", "",
          "",
          "Modifiez les contenus de (votre) vos fiche(s) de poste(s)."
        ),
        step(
          "new-desc", "",
          "",
          "Créez votre (vos) fiche(s) de poste(s)."
        )
      ]
    ),
    page(
      "curriculum_vitae",
      "/curriculumvitae/",
      [
        step(
          "create-cv", "",
          "",
          "Créez un CV au format de votre choix."
        ),
      ]
    ),
    page(
      "account",
      "/parametres-de-compte/informations",
      [
        step(
          "change-password", "",
          "",
          "Cliquez ici pour modifier votre mot de passe."
        ),
      ]
    ),
    page(
      "guests",
      "/gestioninvite",
      [
        step(
          "add-guest", "",
          "",
          "Cliquez ici pour donner un accès à votre Neopass."
        )
      ]
      /**
       * Puis inviter une personne via son adresse mail à rejoindre votre Neopass de manière sécurisée</li><li>Puis cliquez sur "droits d'accès spécifiques" afin de déterminer les page de votre carnet accessibles à votre invité. Ainsi que les pages sur lesquelles il pourra écrire des données.</li><li>Si vous ne souhaitez pas paramétrer de droits d'accès spécifiques, cliquez sur "créer"</li></ol
       */
    ),
  ],

  /* ******************************************************************
    DASHBOARD STEPS
****************************************************************** */
    DASHBOARD_STEPS: [
        /*
        {
            target: '.tour_searchbar',
            header: {
                title: 'Barre de Recherche',
            },
            content: `Recherchez tout type de données dans l'application Neopass.`,
            params: {
                placement: 'bottom',
                enableScrolling: false
            }
        },
        */

    /*
        {
            target: '.tour_messages',
            header: {
                title: 'Messagerie',
            },
            content: 'Accedez à votre messagerie en ligne <br> afin de discuter avec vos collaborateurs.',
            params: {
                placement: 'bottom',
                enableScrolling: false
            }
        },
        */
    /*
        {
            target: '.tour_notifs',
            header: {
                title: 'Notifications',
            },
            content: 'Consultez vos notifications <br> (rappel de dates, tags, partages...',
            params: {
                placement: 'bottom',
                enableScrolling: false
            }
        },
        */
    /*
        {
            target: '.tour_customizedashboard',
            header: {
                title: 'Tableau de bord',
            },
            content: 'Personnalisez l\'affichage de vos modules',
            params: {
                placement: 'top',
                enableScrolling: false
            }
        }
        */
  ],

  /* ******************************************************************
        NEOPASS STEPS
    ****************************************************************** */
  NEOPASS_STEPS: [
    {
      target: '.tour_add_neopass',
      header: {
        title: 'Ajout de Neopass',
      },
      content: 'Créez un nouveau Neopass ou ajoutez un Neopass existant.',
      params: {
        placement: 'left',
        enableScrolling: true
      },
      perm: true,//this.$can('neopass_add')
    },

    /*
        {
            target: '.tour_filter_date',
            header: {
                title: 'Tri par dates',
            },
            content: 'Triez les Neopass par dates de mise à jour de façon chronologique ou antichronologique.',
            params: {
                placement: 'top',
                enableScrolling: false
            }
        },
        */
        {
            target: '.tour_filter_name',
            header: {
                title: 'Tri par ordre alphabétique',
            },
            content: 'Triez les Neopass par ordre alphabétique.',
            params: {
                placement: 'right',
                enableScrolling: true
            },
            perm: true
        },
        {
            target: '.tour_quick_actions',
            header: {
                title: 'Action rapides',
            },
            content: 'Accédez rapidement à certaines fonctionnalités telles que la cartographie ou encore l\'impression du Neopass.',
            params: {
                placement: 'right',
                enableScrolling: true
            },
            perm: true
        }
    ],


  /* ******************************************************************
        NEOPASS FORM STEPS
    ****************************************************************** */
  NEOPASS_FORM_STEPS: [
    {
      target: '.tour__menu_neopass',
      header: {
        title: 'Menu Neopass',
      },
      content: 'Accédez aux différents onglets du Neopass, afin de remplir les formulaires et les évaluations.',
      params: {
        placement: 'bottom',
        enableScrolling: true
      },
      perm: true
    },
    {
      target: '.tour_quick_actions',
      header: {
        title: 'Boutons accès rapide',
      },
      content: 'Imprimez, exportez et accédez aux cartographies en un clic.',
      params: {
        placement: 'bottom',
        enableScrolling: true
      },
      perm: true
    },
    {
      target: '.tour_progress_bar',
      header: {
        title: 'Barre de progression',
      },
      content: 'Suivez l\'état d\'avancement du remplissage de formulaire que vous effectuez. Au début la barre est complètement vide, puis elle se remplit au fur et à mesure de l\'avancement de la tâche pour finir complètement remplie lorsque le remplissage est terminé.',
      params: {
        placement: 'bottom',
        enableScrolling: true
      },
      perm: true
    },
    {
      target: '.tour_save_datas',
      header: {
        title: 'Bouton de sauvegarde',
      },
      content: 'Sauvegardez les modifications que vous effectuez. Si vous fermez ou changez de page sans avoir sauvegardé, vos modifications ne seront pas prises en compte.',
      params: {
        placement: 'right',
        enableScrolling: true
      },
      perm: true,//this.$route.path.split('/form/neopass/')[1] ? this.$can(this.$route.path.split('/form/neopass/')[1].split('/')[2]+'_edit') : false
    }
  ],


  /* ******************************************************************
        MODELES DE PAGES STEPS
    ****************************************************************** */
    MODELES_DE_PAGES_STEPS: [
        {
            target: '.tour_add_modele',
            header: {
                title: 'Ajouter une nouvelle page',
            },
            content: 'Vous pouvez ajouter une nouvelle page de Neopass et personnaliser le contenu comme vous le souhaitez.',
            params: {
                placement: 'bottom',
                enableScrolling: true
            },
            perm: true,//this.$can('templates_add')
        },
        {
            target: '.tour_visualiser',
            header: {
                title: 'Visualiser le modèle',
            },
            content: 'Vous pouvez à tout moment visualiser votre modèle en cours de construction.',
            params: {
                placement: 'top',
                enableScrolling: true
            },
            perm: true,//this.$can('template_preview')
        }
    ],


  /* ******************************************************************
        FICHE DE POSTE BIBLIOTHEQUE COMMUNE STEPS
    ****************************************************************** */
  FDP_COMMUNE_STEPS: [
    {
      target: '.tour_add_personal_library0',
      header: {
        title: 'Ajouter à ma bibliothèque personnelle',
      },
      content: 'Ajoutez à votre bibliothèque personnelle les fiches de poste déjà crées. Vous pourrez ensuite les personnaliser.',
      params: {
        placement: 'right',
        enableScrolling: false
      },
      perm: true,//this.$can('job_description_shared_add_to_personnal')
    },
  ],


  /* ******************************************************************
        FICHE DE POSTE BIBLIOTHEQUE PERSONNELLE STEPS
    ****************************************************************** */
  FDP_PERSO_STEPS: [
    {
      target: '.tour_blibliotheque_commune',
      header: {
        title: 'Bibliothèque Commune',
      },
      content: 'Ajoutez à votre bibliothèque personnelle des fiches de poste déjà crées depuis la bibliothèque commune. Vous pourrez ensuite les personnaliser.',
      params: {
        placement: 'top',
        enableScrolling: true
      },
      perm: true,//this.$can('job_description_shared_list')
    },
    {
      target: '.tour_fiches_postes_filtrer',
      header: {
        title: 'Filtrer',
      },
      content: 'Afin de faciliter vos recherches de fiches de poste, vous pouvez les filtrer par familles professionnelles ou secteurs d\'activités.',
      params: {
        placement: 'right',
        enableScrolling: false
      },
      perm: true
    }
  ],


  /* ******************************************************************
        CARTOGRAPHIES INDIVIDUELLES STEPS
    ****************************************************************** */
  CARTOGRAPHIES_INDIVIDUELLES_STEPS: [
    {
      target: '.tour_carto_print',
      header: {
        title: 'Impression de Cartographies',
      },
      content: 'Imprimez vos cartographies afin de les inclure à vos bilans et rapports.',
      params: {
        placement: 'left',
        enableScrolling: true
      }
    },
    {
      target: '.tour_comparer_carto',
      header: {
        title: 'Comparaison de Cartographies',
      },
      content: 'Enregistrez vos cartographies à différentes dates afin de comparer les évolutions.',
      params: {
        placement: 'bottom',
        enableScrolling: true
      }
    },
  ],
}

;